<template>
  <div class="d-flex flex-grow-1">
    <div class="te-main bg-white h-100 flex-grow-1 d-flex flex-column">
      <div class="te-content bg-white w-100 flex-grow-1 overflow-y">
        <div class="h-100 container-fluid p-0 overflow-auto">
          <div class="h-100 row no-gutters">
            <div class="d-flex justify-content-center align-items-center flex-column flex-grow-1">
              <div class="w-50 d-flex justify-content-center align-items-center">
                <img src="@/assets/images/illus_empty.png" class="mw-100">
              </div>
              <p class="my-3 w-100 text-center text-primary font-size-md">
                {{ $t('admin.Nop.Hint') }}
              </p>
              <b-button variant="success" size="sm" pill class="px-3 d-flex align-items-center" @click="OpenUrl">
                <span>{{ $t('admin.Nop.Btn') }}</span>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>

</style>

<script>
import PermissionService from '@/services/PermissionService';

export default {
  name: 'Emtpy',
  data() {
    return {
      domain: ''
    };
  },
  async created() {
    await this.LoadAsync();
  },
  methods: {
    async LoadAsync() {
      const vm = this;
      const ecSetting = await PermissionService.GetElectronicCommerceAsync();
      if (ecSetting && ecSetting[0]) {
        vm.domain = ecSetting[0].domainUrl;
      }
    },
    OpenUrl() {
      const vm = this;
      window.open(`${vm.domain}AdministratorLogin`);
    }
  }
};
</script>
